export default {
  momentLocale: 'en',
  Timeline: {
    expand: 'Expand',
    fold: 'Fold',
  },
  Balloon: {
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  Card: {
    expand: 'Expand',
    fold: 'Fold',
  },
  Calendar: {
    today: 'Today',
    now: 'Now',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    prevYear: 'Previous Year',
    nextYear: 'Next Year',
    prevMonth: 'Previous Month',
    nextMonth: 'Next Month',
    prevDecade: 'Previous Twelve Years',
    nextDecade: 'Next Twelve Years',
    yearSelectAriaLabel: 'Select Year',
    monthSelectAriaLabel: 'Select Month',
    format: {
      months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
        '_',
      ),
      shortMonths: 'Jan._Feb._Mar._Apr._May._Jun._Jul._Aug._Sep._Oct._Nov._Dec.'.split('_'),
      weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      shortWeekdays: 'Sun._Mon._Tues._Wed._Thur._Fri._Sat.'.split('_'),
      veryShortWeekdays: 'Su._Mo._Tu._We._Th._Fr._Sa.'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Select Date',
    datetimePlaceholder: 'Select Date And Time',
    monthPlaceholder: 'Select Month',
    yearPlaceholder: 'Select Year',
    now: 'Now',
    selectTime: 'Select Time',
    selectDate: 'Select Date',
    ok: 'OK',
    clear: 'Clear',
    startPlaceholder: 'Start Date',
    endPlaceholder: 'End Date',
    hour: 'H',
    minute: 'M',
    second: 'S',
  },
  Dialog: {
    close: 'Close',
    ok: 'OK',
    cancel: 'Cancel',
  },
  Message: {
    closeAriaLabel: 'Close',
  },
  Pagination: {
    goTo: 'Go to',
    page: 'Page',
    total: 'Page {current} of {total}',
    labelPrev: 'Previous page, current page {current}',
    labelNext: 'Next page, current page {current}',
    inputAriaLabel: 'Please enter what page to skip to',
    selectAriaLabel: 'Please select how many items are displayed on each page',
    pageSize: 'item(s)/page',
  },
  Input: {
    clear: 'Clear',
  },
  Select: {
    selectPlaceholder: 'Please Select',
    autoCompletePlaceholder: 'Please Input',
    notFoundContent: 'No Options',
    maxTagPlaceholder: 'Selected {selected}/{total} in total',
  },
  Table: {
    empty: 'No Data',
    ok: 'OK',
    reset: 'Reset',
    asc: 'Ascend',
    desc: 'Descend',
    expanded: 'Expanded',
    folded: 'Folded',
    filter: 'Filter',
    selectAll: 'Select All',
  },
  TimePicker: {
    placeholder: 'Select Time',
    startPlaceholder: 'Start Time',
    endPlaceholder: 'End Time',
    clear: 'Clear',
    hour: 'H',
    minute: 'M',
    second: 'S',
  },
  Transfer: {
    items: 'items',
    item: 'item',
    moveAll: 'Move All',
    searchPlaceholder: 'Please Input',
    moveToLeft: 'Uncheck Selected Elements',
    moveToRight: 'Submit Selected Elements',
  },
  Upload: {
    card: {
      cancel: 'Cancel',
      addPhoto: 'Upload Image',
      download: 'Download',
      delete: 'Delete',
    },
    drag: {
      text: 'Click or drag the file to this dashed area to upload',
      hint: 'Support docx, xls, pdf, rar, zip, png, jpg and other types of files',
    },
    upload: {
      delete: 'Delete',
    },
  },
  Search: {
    buttonText: 'Search',
  },
  Tag: {
    delete: 'Delete',
  },
  Rating: {
    description: 'Rating Options',
  },
};
